
// ⚠️ Assure-toi d'importer le CSS une seule fois dans ton bundle (ou layout)
// import "tippy.js/dist/tippy.css"; // nécessaire pour les thèmes/animations de base
// import "tippy.js/animations/scale.css";    // si tu utilises animation: "scale"
// import "tippy.js/animations/shift-away.css";
// import "tippy.js/animations/shift-toward.css";
// import "tippy.js/animations/perspective.css";




// import tippy from "tippy.js";
// import { Controller } from "stimulus";

// import Rails from "@rails/ujs";

// export default class extends Controller {
//   static values = {
//     targetId: String,
//     placement: String,
//     onlyIfTruncated: Boolean // pas d'objet {type, default} pour compat < 3.2
//   }

//   connect() {
//     // Observe la taille pour activer/désactiver dynamiquement le tooltip
//     this._onResize = () => this._refresh();
//     this._ro = new ResizeObserver(this._onResize);
//     this._ro.observe(this.element);

//     // Petit rafraîchissement différé pour laisser le layout se stabiliser
//     requestAnimationFrame(() => this._refresh());
//   }

//   disconnect() {
//     this._destroyTippy();
//     if (this._ro) this._ro.disconnect();
//   }

//   // Si une value change dynamiquement
//   targetIdValueChanged()   { this._refresh(); }
//   onlyIfTruncatedValueChanged() { this._refresh(); }
//   placementValueChanged() {
//     if (this.element._tippy) {
//       this.element._tippy.setProps({ placement: this.placementValue || "right" });
//     } else {
//       this._refresh();
//     }
//   }

//   _refresh() {
//     const targetId = this.targetIdValue;
//     const contentEl = targetId ? document.getElementById(targetId) : null;

//     if (!contentEl) {
//       // Pas de contenu → pas de tooltip
//       this._destroyTippy();
//       if (targetId) console.warn(`[tooltip] target #${targetId} not found`);
//       return;
//     }

//     // Valeur booléenne avec fallback à false si absente
//     const onlyIfTruncated = this.hasOnlyIfTruncatedValue ? this.onlyIfTruncatedValue : false;

//     const truncated = this._isTruncated(this.element);
//     if (onlyIfTruncated && !truncated) {
//       this._destroyTippy();
//       return;
//     }

//     const html = contentEl.innerHTML;
//     const placement = this.placementValue || "right";

//     if (this.element._tippy) {
//       // Mise à jour
//       this.element._tippy.setContent(html);
//       this.element._tippy.setProps({ placement });
//     } else {
//       // Création
//       tippy(this.element, {
//         content: html,
//         allowHTML: true,
//         placement,
//         onShow: () => {
//           // Si entre-temps ce n’est plus tronqué, n’affiche pas
//           if (onlyIfTruncated && !this._isTruncated(this.element)) return false;
//         }
//       });
//     }
//   }

//   _isTruncated(el) {
//     // Nécessite côté CSS : white-space: nowrap; overflow: hidden; text-overflow: ellipsis; + max-width
//     return el.scrollWidth > el.clientWidth;
//   }

//   _destroyTippy() {
//     if (this.element._tippy) {
//       this.element._tippy.destroy();
//       delete this.element._tippy;
//     }
//   }
// }





 


import tippy from "tippy.js";
import { Controller } from "stimulus";
export default class extends Controller {
  static values = {
    // Compatibilité avec ton code existant
    targetId: String,
    placement: String,
    onlyIfTruncated: Boolean,

    // Nouveau : toutes options Tippy en JSON (prioritaires)
    // ex: data-tooltip-options-value='{"interactive":true,"theme":"light","animation":"scale"}'
    options: Object,

    // Optionnel : contenu direct si tu ne veux pas targetId
    content: String
  }

  connect() {
    // ResizeObserver pour gérer onlyIfTruncated en live
    this._onResize = () => this._refresh();
    this._ro = new ResizeObserver(this._onResize);
    this._ro.observe(this.element);

    // MutationObserver : si les data-* changent, on reconfigure
    this._mo = new MutationObserver((muts) => {
      if (muts.some(m => m.type === "attributes" && m.attributeName?.startsWith("data-"))) {
        this._refresh();
      }
    });
    this._mo.observe(this.element, { attributes: true });

    // Laisse le layout se stabiliser
    requestAnimationFrame(() => this._refresh());
  }

  disconnect() {
    this._destroyTippy();
    if (this._ro) this._ro.disconnect();
    if (this._mo) this._mo.disconnect();
  }

  // Réactivité des values
  targetIdValueChanged()        { this._refresh(); }
  onlyIfTruncatedValueChanged() { this._refresh(); }
  contentValueChanged()         { this._refresh(); }
  optionsValueChanged()         { this._refresh(); }
  placementValueChanged() {
    if (this.element._tippy) {
      this.element._tippy.setProps({ placement: this.placementValue || "right" });
    } else {
      this._refresh();
    }
  }

  // Public
  refresh() { this._refresh(); }

  // ----------------- Private -----------------
  _refresh() {
    const instance = this.element._tippy;

    // 1) Base (compat existante)
    const base = {
      allowHTML: true,
      placement: this.placementValue || "right"
    };

    // 2) Contenu (targetId > content value > laisser Tippy gérer)
    const content = this._resolveContent();
    if (content !== undefined) base.content = content;

    // 3) onlyIfTruncated (fallback false)
    const onlyIfTruncated = this.hasOnlyIfTruncatedValue ? this.onlyIfTruncatedValue : false;

    // 4) Options via data-* (supporte data-tippy-xxx et data-tooltip-xxx)
    const datasetOpts = this._readOptionsFromDataset(["tippy", "tooltip"]);

    // 5) Options JSON complètes
    const jsonOpts = this.optionsValue || {};

    // 6) Résolution des fonctions passées en string (onShow: "App.fn")
    const resolvedJsonOpts = this._resolveFunctionProps(jsonOpts);

    // 7) Merge final (priorité: JSON > data-* > base)
    const finalOpts = {
      ...base,
      ...datasetOpts,
      ...resolvedJsonOpts
    };

    // 8) Guard onlyIfTruncated au show (et chaîne avec éventuel onShow utilisateur)
    finalOpts.onShow = this._chain(finalOpts.onShow, () => {
      if (!onlyIfTruncated) return true;
      return this._isTruncated(this.element);
    });

    // 9) Si demandé et pas tronqué, on détruit/évite création
    if (onlyIfTruncated && !this._isTruncated(this.element)) {
      this._destroyTippy();
      return;
    }

    // 10) Update vs create
    if (instance) {
      if (Object.prototype.hasOwnProperty.call(finalOpts, "content")) {
        instance.setContent(finalOpts.content);
      }
      const { content: _c, ...props } = finalOpts;
      instance.setProps(props);
    } else {
      tippy(this.element, finalOpts);
    }
  }

  _resolveContent() {
    const targetId = this.targetIdValue;
    if (targetId) {
      const el = document.getElementById(targetId);
      if (!el) {
        console.warn(`[tooltip] target #${targetId} not found`);
        // null => pas de tooltip ; undefined => laisse Tippy gérer ; on veut désactiver => null
        return null;
      }
      return el.innerHTML;
    }
    if (this.hasContentValue) return this.contentValue;
    // ni targetId ni content => undefined : Tippy peut lire data-tippy-content si présent
    return undefined;
  }

  _isTruncated(el) {
    return el.scrollWidth > el.clientWidth;
  }

  _destroyTippy() {
    if (this.element._tippy) {
      this.element._tippy.destroy();
      delete this.element._tippy;
    }
  }

  _readOptionsFromDataset(prefixes = ["tippy"]) {
    const out = {};
    const ds = this.element.dataset;

    const parse = (val) => this._autoCast(val);

    Object.keys(ds).forEach(k => {
      const pref = prefixes.find(p => k.startsWith(p));
      if (!pref) return;
      const raw = k.slice(pref.length); // "Interactive", "MaxWidth", ...
      if (!raw) return;
      const camel = raw[0].toLowerCase() + raw.slice(1);
      const v = ds[k];
      if (v != null) out[camel] = parse(v);
    });

    // Contenu direct via data-tippy-content / data-tooltip-content
    for (const p of prefixes) {
      const key = (p + "Content").replace(/-([a-z])/g, (_, c) => c.toUpperCase());
      if (ds[key] != null && out.content == null) out.content = ds[key];
    }

    return out;
  }

  _autoCast(v) {
    const s = String(v).trim();
    if (s === "true") return true;
    if (s === "false") return false;
    if (s === "null") return null;
    if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
    if ((s.startsWith("{") && s.endsWith("}")) || (s.startsWith("[") && s.endsWith("]"))) {
      try { return JSON.parse(s); } catch { /* noop */ }
    }
    // Fonction globale ("App.tooltips.onShow")
    if (/^[A-Za-z_$][\w.$]*$/.test(s)) {
      const fn = this._lookup(window, s);
      if (typeof fn === "function") return fn;
    }
    return v;
  }

  _resolveFunctionProps(opts) {
    const out = { ...opts };
    const fnKeys = [
      "onShow","onHide","onMount","onTrigger","onUntrigger","onClickOutside","onCreate","onDestroy"
    ];
    fnKeys.forEach(k => {
      if (typeof out[k] === "string") {
        const fn = this._lookup(window, out[k]);
        if (typeof fn === "function") out[k] = fn;
      }
    });
    return out;
  }

  _lookup(root, path) {
    try { return path.split(".").reduce((a, p) => (a ? a[p] : undefined), root); }
    catch { return undefined; }
  }

  _chain(...fns) {
    return (inst) => {
      for (const fn of fns) {
        if (typeof fn === "function") {
          const res = fn(inst);
          if (res === false) return false;
        }
      }
      return true;
    };
  }
}
